





























































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { GEnum } from '@/constants/enum.defination';
import { Component } from 'vue-property-decorator';
import { GroupSetting } from '@/models/school-group/group-setting';
import { required, maxLength } from 'vuelidate/lib/validators';
import { masterModule } from '@/store/modules/entities/master.module';
import { groupModule } from '@/store/modules/entities/group.module';
import { GroupModalProperty } from '@/models/school-group/group-modal-property';
import GVTag from '@/components/GVTag.vue';
import { studentModule } from '@/store/modules/entities/student.module';
import { GrowingPurpose } from '@/models/student/growing-purpose';
import { customCompetencyModule } from '@/store/modules/frames/custom-competency.module';
import { CustomCompetency } from '@/models/competency/competency';
import { SchoolGroupGrowingPurpose } from '@/models/school-group/school-group-growing-purpose';

@Component({
  name: 'GClassManagementGroupSetting',
  components: {
    GVTag,
  },
  computed: {},
  methods: {},
  validations: {
    groupName: { required, maxLength: maxLength(64) },
    notes: { maxLength: maxLength(64) },
  },
})
export default class GClassManagementGroupSetting extends mixins(GPageBase) {
  groupName: string = '';
  numberOfGroups: number = 2;
  purposeOfTraining: number = 0;
  groupType: number = 1;
  notes: string = '';
  schoolCompetencyID: number = 0;

  async mounted() {
    await masterModule.fetchValidGrowingPurposes(1);
    await customCompetencyModule.fetchCustomCompetency();
    this.initDefaultGrowingPurpose();
  }

  get validGrowingPurposes(): GrowingPurpose[] {
    const growingPurposes: GrowingPurpose[] = masterModule.validGrowingPurposes;
    return growingPurposes;
  }

  get validGrowingPurposesAndSchoolCompetencies(): SchoolGroupGrowingPurpose[] {
    var count = 0;
    const growingPurposes: SchoolGroupGrowingPurpose[] = masterModule.validGrowingPurposes.map((gp: GrowingPurpose) => {
        count++;
        return {
          tmpID: count,
          growingPurposeID: gp.growingPurposeID,
          title: gp.title,
          isSchoolCompetency: false,
        } as SchoolGroupGrowingPurpose;
      });
    // 学校コンピテンシーが存在すれば、それを「育成目的」（GrowingPurpose）として扱う
    
    var customCompetencies: SchoolGroupGrowingPurpose[] = [];
    if (this.customCompetencies.length > 0) {
      customCompetencies = this.customCompetencies.map((cComp) => {
        count++;
        return {
          tmpID: count,
          growingPurposeID: cComp.id,
          title: cComp.name,
          isSchoolCompetency: true,
        } as SchoolGroupGrowingPurpose;
      });
    }
    return growingPurposes.concat(customCompetencies);
  }

  initDefaultGrowingPurpose(): void {
    if (this.validGrowingPurposes) {
      const [firstGrowingPurpose] = this.validGrowingPurposes;
      this.purposeOfTraining = firstGrowingPurpose.growingPurposeID;
    }
  }

  // NOTE: [3, 4, ... , (グループ数の最大: n)]の配列を返却
  get computedGroupNum(): number[] {
    const maxGroupCount = Math.floor(this.targetStudentTotalRecords / 3) - 1;
    return Array.from({ length: maxGroupCount }, (_, i) => i + 2);
  }

  get targetStudentTotalRecords(): number {
    return studentModule.students.totalRecords;
  }

  get isShowGroupSettingModal(): boolean {
    return groupModule.groupModalProperty.isShowGroupsettingModal;
  }

  get isGroupNameRequired(): boolean {
    return this.$v.groupName.$dirty && this.$v.groupName.required == false;
  }

  get isGroupNameEmpty(): boolean {
    this.$v.groupName.$touch();
    return this.$v.groupName.required == false;
  }

  get isGroupNameMaxLength(): boolean {
    return this.$v.groupName.$dirty && this.$v.groupName.maxLength === false;
  }

  get isNotesMaxLength(): boolean {
    return this.$v.notes.$dirty && this.$v.notes.maxLength === false;
  }

  get hasInputGroupName(): boolean {
    return this.groupName.length > 0;
  }

  get customCompetencies(): CustomCompetency[] {
    return customCompetencyModule.customCompetencies;
  }

  // 育成目的の選択 : 育成目的の選択肢は、育成目的（growingPurpose）と、学校コンピテンシーが混在している
  handleChangeGrowingPurpose(selectID: number) {
    const selected = this.validGrowingPurposesAndSchoolCompetencies.find((d: SchoolGroupGrowingPurpose) => {
      if (d.tmpID === selectID) return d;
    });
    if (selected.isSchoolCompetency) {
      // 学校コンピテンシーが選択された場合、[ purposeOfTraining ] （growingPurpose）はAPI側で無視されるので何もしない
      this.schoolCompetencyID = selected.growingPurposeID;
    } else {
      this.purposeOfTraining = selected.growingPurposeID;
      // 「育成目的」（growingPurpose）が選択された場合、学校コンピテンシーは 0 にしておく
      this.schoolCompetencyID = 0;
    }
  }

  handleGroupSettingFormData() {
    if (this.isGroupNameRequired || this.isGroupNameEmpty) {
      this.showNotice(GEnum.MessageType.Error, 'Error!', 'Group name is mandatory');
    } else if (this.isNotesMaxLength) {
      this.showNotice(GEnum.MessageType.Error, 'Error!', 'Notes should not more than 64 characters');
    } else {
      groupModule.setGroupSetting({
        groupName: this.groupName,
        numberOfGroups: this.numberOfGroups,
        purposeOfTraining: this.purposeOfTraining,
        groupType: this.groupType,
        notes: this.notes,
        schoolCompetencyID: this.schoolCompetencyID,
      } as GroupSetting);
      const schoolGroupSettingInfoOptions = {
        isShowGroupsettingModal: false,
        isGroupSettingsDataSubmitted: true,
      } as GroupModalProperty;
      groupModule.setSchoolGroupSettingInfo(schoolGroupSettingInfoOptions);
    }
  }
}
